<template>
  <div id="app">
    <!-- Comprobamos el estado del store, si está identificado mostramos un template sino, el login -->
    <template v-if="loggedIn">
      <v-app id="inspire" class="app">
        <profile-view/>
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <v-footer height="auto" class="white pa-3 app--footer">
            <span class="caption">Cicerón &copy; {{ new Date().getFullYear() }}</span>
            <v-spacer></v-spacer>
            <TermsDialog></TermsDialog>
          </v-footer>
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- <v-navigation-drawer class="setting-drawer" temporary right false hide-overlay fixed></v-navigation-drawer> -->
        <v-snackbar v-model="isOffline" center :timeout="0" top color="error">{{$t('error.notConnection')}}</v-snackbar>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>
<script>
import AppDrawer from './components/ui/AppDrawer'
import AppToolbar from './components/ui/AppToolbar'
import AppFab from './components/ui/AppFab'
import PageHeader from './components/ui/PageHeader'
import TermsDialog from './components/widgets/Terms'
import ProfileView from './components/configuration/profile/ProfileView'
import menu from './api/menu'
import AppEvents from './event'
import { mapState, mapActions } from 'vuex'
import { apiAxios } from './helpers'
export default {
  name: 'app',
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    TermsDialog,
    ProfileView
  },
  data() {
    return {
      isOffline: false
    }
  },
  created() {
    this.refreshPermissions()
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback)
    })
    window.getApp = this

    let vm = this
    window.addEventListener('offline', function(e) {
      vm.isOffline = true
    })

    window.addEventListener('online', function(e) {
      vm.isOffline = false
    })
  },
  /* Store del estado del inicio de sesión */
  computed: {
    ...mapState({
      loggedIn: state => state.authentication.status.loggedIn
    }),
    online() {
      return window.navigator.onLine
    }
  },
  methods: {
    ...mapActions({
      refreshPermissions: 'authentication/refreshPermissions'
    })
  },
  watch: {
    online(val) {
      console.log('online', val)
    }
  }
}
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}
</style>
